import { IApplicationState } from '../../types/redux';

export function getGeoSubdomain(state: IApplicationState): string {
  return state.geoSubdomain;
}
